// Une fois que la page est chargée
window.addEventListener("DOMContentLoaded", () => {

  // Megamenu au survol
  $(".header__inline-menu details").hover(function (e) {
    $(this).attr("open", true);
    $(this).find(".header__submenu").mouseleave(function (e) {
      $(this).parent().removeAttr("open");
    });
  }, function (e) {
    $(this).attr("open", false);
  });

  initURLTarget(); // Initialise les data-url_target cliquables

  // Redirection reassurance item
  $(document).on('click', '.reassurance__item', function () {
    var url = $(this).find("a").attr("href");
    if (url) {
      window.location.href = url;
    }
  });

  // Menu
  // Au clic sur #search-icon on ajoute la classe overflow-hidden-modal-opened à body
  $(document).on('click', '.header__icon', function () {
    $("body").toggleClass("overflow-hidden-modal-opened");
  });


  $(document).on('click', '.modal__close-button', function () {
    $("body").removeClass("overflow-hidden-modal-opened");
  });

  $(document).on('click', '.product_agec .h4', function () {
    $(this).next("p").slideToggle();
  });

  // Ouverture et fermeture guide des tailles
  $(document).on('click', '.sizing_guide', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_sizing.drawer").addClass("active");
  });

  $(document).on('click', '#drawer_sizing.drawer .icon-close, #drawer_sizing.drawer', function () {
    $("#drawer_sizing.drawer").removeClass("active");
    setTimeout(() => {
      $("body").removeClass("overflow-hidden");
    }, 800);
  });

  $(document).on('click', '.shop_availability', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_disponibilite.drawer").addClass("active");
  });

  $(document).on('click', '#drawer_disponibilite.drawer .icon-close, #drawer_disponibilite.drawer', function () {
    $("#drawer_disponibilite.popin_shop_availability").removeClass("active");
    setTimeout(() => {
      $("body").removeClass("overflow-hidden");
    }, 800);
  });

  // Fermeture des popins au clic en dehors de la popin
  $(document).on('click', '.drawer_wrapper_inner', function (event) {
    event.stopPropagation();
  });

  // Page collection
  // ----------------------------------------------------------------------------
  // Filtres
  // Ouverture tabs
  $(document).on("click", ".mobile-facets__summary", function () {
    $(this).toggleClass("active");
    $(this).next().toggle();
  });

  // Quick add to card PLP
    $(document).on("click", "[data-card_product_variant_id]", function (e) {
    // prevent default action
    e.preventDefault();
    // prevent propagation
    e.stopPropagation();

    // si l'élément cliqué à une classe "disabled" on ne fait rien
    if ($(this).hasClass("disabled")) {
      return;
    }

    var $this = $(this);
    var variantId = $this.data("card_product_variant_id");
    var $form = $this.closest("product-form");
    var $input = $form.find('input[name="id"]');

    if ($input.length) {
      $input.val(variantId);
      $form.trigger("change");
    }
     $(this).closest('form').find('.quick-add__submit').click();
  });

  // Voir plus
  if ($(".clamped").length) {
  $(document).on("click", ".read_more", function () {
    var $clamped = $(this).prev(".clamped");

    if (!$clamped.hasClass("extend")) {
      // OUVRIR
      $clamped.css("height", $clamped.prop("scrollHeight") + "px");
      $clamped.addClass("extend");
    } else {
      // FERMER
      $clamped.css("height", "");
      $clamped.removeClass("extend");

      var $section = $clamped.closest('[class*="section-"][class*="-padding"]');

      if ($section.length) {
        $("html, body").animate(
          {
            scrollTop: $section.offset().top - 60,
          },
          400
        );
      }
    }

    $(this).find(".show, .hide").toggleClass("show hide");
  });
}

  // accordeon
   // Comportement questions FAQ, CGV, Mentions
   $(".accordeon").on("click", "h3", function () {
    var $currentQ = $(this);
    var $currentA = $currentQ.next("div");

    // Ferme toutes les autres réponses + retire leurs classes
    $(".accordeon h3").not($currentQ).removeClass("opened");
    $(".accordeon h3").not($currentQ).next("div").stop(true, true).slideUp();

    // Toggle sur l'élément cliqué
    if ($currentQ.hasClass("opened")) {
      $currentQ.removeClass("opened");
      $currentA.stop(true, true).slideUp();
    } else {
      $currentQ.addClass("opened");
      $currentA.stop(true, true).slideDown();
    }
  });

  // Fibble
  $("fibbl-layer").on('fibbl-ready', function () {
    $("#fibbl_vto_button_active").show();
  });

  // Footer
  // ----------------------------------------------------------------------------
  // Accordeon Footer mobile
  function footerAccordion() {
    if ($(window).width() <= 749) {
      $('.footer-block__details-content').hide();

      $('.footer-block__heading').off('click').on('click', function () {
        const $block = $(this).closest('.footer-block');
        const $content = $block.find('.footer-block__details-content');

        $(this).toggleClass('is-open');
        $content.stop(true, true).slideToggle(300);
      });
    } else {
      $('.footer-block__details-content').show();
      $('.footer-block__heading').removeClass('is-open').off('click');
    }
  }

  footerAccordion();
  $(window).on('resize', footerAccordion);

  // Swiper quicklinks
  var variantListPdpSwiper = new Swiper(".quicklinks_wrapper", {
    slidesPerView: "auto",
    grabCursor: true,
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
  });
});

// Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
function initURLTarget() {
  document.querySelectorAll("[data-url_target]").forEach(element => {
    element.addEventListener("click", () => {
      const url = element.dataset.url_target;
      if (url && url !== "#") {
        window.location.href = url;
      }
    });
  });
}


// Instagram swiper
class InstagramSwiper extends HTMLElement {
  constructor() {
    super();
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 3;
    this.slidesPerView = parseInt(this.dataset.slidesPerView) || 4;
    this.spaceBetween = parseInt(this.dataset.spaceBetween) || 24;
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const slidesCount = this.querySelectorAll('.swiper .swiper-slide').length;
    const swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: this.spaceBetween,
      loop: slidesCount > 1,
      loopAdditionalSlides: 2,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        enabled: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        750: {
          slidesPerView: this.slidesPerView,
          spaceBetween: this.spaceBetween,
        },
      },
    };

    // Ajouter l'autoplay si activé
    if (this.autoplay) {
      swiperConfig.autoplay = {
        delay: this.autoplayDelay * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    new Swiper(this.querySelector(".swiper"), swiperConfig);

    // Empêcher la propagation des clics sur les contrôles
    this.querySelectorAll(".swiper-button-next, .swiper-button-prev").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });
  }
}
customElements.define("instagram-swiper", InstagramSwiper);

class CardProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwipers();
  }

  initSwipers() {
    $(this).find(".mySwiper").not(".no-swiper").each(function () {
      var $swiperContainer = $(this);
      var swiperElement = $swiperContainer.get(0);

      // Already initialized swiper, skip
      if (swiperElement?.swiper) return;

      // Clean old swiper classes from cached HTML before init
      $swiperContainer
        .removeClass("swiper-initialized swiper-horizontal swiper-backface-hidden")
        .find(".swiper-wrapper, .swiper-slide")
        .removeAttr("style");

      var slidesCount = $swiperContainer.find(".swiper-slide").length;
      var hasMultipleSlides = slidesCount > 1;
      var nextEl = $swiperContainer.find(".swiper-button-next").get(0);
      var prevEl = $swiperContainer.find(".swiper-button-prev").get(0);
      var paginationEl = $swiperContainer.find(".swiper-pagination").get(0);

      $swiperContainer.toggleClass("is-single-slide", !hasMultipleSlides);

      var disableMobileTouch = $swiperContainer.hasClass("no-mobile-swiper");

      new Swiper(swiperElement, {
        loop: hasMultipleSlides,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
          enabled: hasMultipleSlides,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        preventClicks: true,
        preventClicksPropagation: true,
        breakpoints: {
          0: { allowTouchMove: !disableMobileTouch },
          789: { allowTouchMove: true },
        }
      });

      $swiperContainer.find(".swiper-button-next, .swiper-button-prev").off("click.cardSwiper").on("click.cardSwiper", function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
    });
  }

}
customElements.define("card-product", CardProduct);

// Programmation de diffusion (snippet schedule-attributes) : l'état calculé par le serveur peut dater
// (page en cache) ; on le recalcule avec l'heure du navigateur, puis à chaque début / fin dans les 24 h.
(function () {
  var timer;

  function refreshSchedules() {
    clearTimeout(timer);
    var now = Date.now() / 1000;
    var next = Infinity;

    document.querySelectorAll("[data-schedule-state]").forEach(function (el) {
      var start = Number(el.dataset.scheduleStart) || 0;
      var end = Number(el.dataset.scheduleEnd) || 0;
      var phase = start && now < start ? "before" : end && now >= end ? "after" : "active";
      el.dataset.scheduleState = phase === "active" ? "on" : "off";
      el.dataset.schedulePhase = phase;
      [start, end].forEach(function (time) {
        if (time > now && time < next) next = time;
      });
    });

    if (next - now < 86400) timer = setTimeout(refreshSchedules, (next - now) * 1000 + 500);
  }

  document.addEventListener("DOMContentLoaded", refreshSchedules);
  document.addEventListener("shopify:section:load", refreshSchedules);
})();
